import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { logout } from '../lib/allauth'
import { URLs } from '../auth'
import { Card, Button, Typography } from 'antd'

const { Title, Text } = Typography

export default function Logout () {
  const [response, setResponse] = useState({ fetching: false, content: null })

  function submit () {
    setResponse({ ...response, fetching: true })
    logout().then((content) => { setResponse((r) => { return { ...r, content } }) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }
  if (response.content) return <Navigate to={URLs.LOGOUT_REDIRECT_URL} replace />
  return (
    <div style={{ maxWidth: 340, margin: '48px auto', textAlign: 'center' }}>
      <Card>
        <Title level={2} className='tti-page-title'>Logout</Title>
        <Text type='secondary'>Are you sure you want to logout?</Text>
        <div style={{ marginTop: 20 }}>
          <Button type='primary' loading={response.fetching} onClick={() => submit()} style={{ color: '#FFFFFF' }}>Logout</Button>
        </div>
      </Card>
    </div>
  )
}
